import React from 'react';
import { useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import ServicesManager from '../../components/services/ServicesManager';

const SuperAdminEditServicesPage: React.FC = () => {
    const { siteId } = useParams();
    if (!siteId) return <Typography color="error" sx={{ p: 3 }}>Missing site ID</Typography>;
    return <ServicesManager tenantId={siteId} />;
};

export default SuperAdminEditServicesPage;
